<template>
  <header class="header">
    <div class="container">
      <div class="header__inner">
        <a href="/" class="header__logo">
          <img
            src="~/assets/img/main/logo--mts.svg"
            alt="Webinar"
            class="header__logo_img"
            width="104"
            height="40"
          />
        </a>
        <div class="header__btn-list">
          <VButtonMTSV2
            class="header__btn --burger"
            data-toggle="slideout-button"
            aria-label="Aria Open menu"
            @click="$emit('openSidebar')"
          >
            <VIconMTS
              :name="'mts/icon-mts--menu'"
              :width="24"
              :height="24"
              fill="#1D2023"
              class="header__btn-icon"
            />
          </VButtonMTSV2>

          <VButtonLinkMTSV2
            href="javascript:void(0);"
            class="header__btn --signin --grey --s"
            @click="sendMetricsSigninClient"
          >
            <span>Войти</span>
          </VButtonLinkMTSV2>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import VButtonLinkMTSV2 from '~/components/Common/MTS/VButtonLinkMTSV2'
import VButtonMTSV2 from '~/components/Common/MTS/VButtonMTSV2'
import VIconMTS from '~/components/Common/MTS/VIconMTS.vue'
import HeaderMixin from '~/components/Desktop/Header/mixins/HeaderMixin'

export default {
  name: 'HeaderMobile',
  components: { VButtonLinkMTSV2, VButtonMTSV2, VIconMTS },
  mixins: [HeaderMixin],
}
</script>

<style lang="scss" scoped>
.header {
  background: #fff;
  position: relative;
  padding: 6px 0;
  font-family: 'MTS Compact', 'Arial', sans-serif;
  z-index: 450;

  .container {
    padding-left: 20px;
    padding-right: 20px;
  }

  &__inner {
    display: flex;
    align-items: center;
  }
  &__btn {
    justify-content: center;

    @include screen-up('lg') {
      flex: 0 auto;
    }

    &-list {
      display: flex;
      column-gap: 12px;
      align-items: center;
      margin-right: 0;
      margin-left: auto;
    }
    &-icon {
      flex: 1 24px;
    }

    &.--burger {
      padding: 0;
      @include screen-up('lg') {
        display: none;
      }
    }
  }
}
</style>
